import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/core/components/ui/dialog";
import { Progress } from "@/core/components/ui/progress";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ExportInsightsGeneratingDialogProps } from "../types";

export function ExportInsightsGeneratingDialog({
  open,
  progress,
  currentStep,
}: ExportInsightsGeneratingDialogProps) {
  const [translate] = useTranslation(["insights"]);
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="max-w-md bg-secondary"
        aria-describedby="Gerando seu relatório"
      >
        <DialogTitle className="text-lg font-semibold">
          {translate("export-insights-generating-dialog-title")}
        </DialogTitle>
        <div className="flex flex-col items-center justify-center py-8 space-y-6">
          <DialogDescription className="text-sm text-center text-gray-500 max-w-xs mb-4">
            {translate("export-insights-generating-dialog-description")}
          </DialogDescription>
          <div className="p-4 bg-secondary-200 rounded-full">
            <FileText className="h-8 w-8 text-primary" />
          </div>
          <div className="text-center space-y-2">
            <p className="text-sm text-muted-950">{currentStep}</p>
          </div>
          <div className="w-full space-y-2">
            <Progress value={progress} className="h-2" />
            <div className="flex justify-between items-center text-xs text-muted-950">
              <span>
                {translate("export-insights-generating-dialog-processing-data")}
              </span>
              <span className="font-medium">{Math.round(progress)}%</span>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
